var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.96734 2.08858C7.30293 2.03035 7.64807 2 8.0003 2C11.314 2 14.0003 4.68629 14.0003 8C14.0003 8.95871 13.7754 9.86491 13.3756 10.6687L15.1921 11.5082C15.7098 10.4489 16.0003 9.25841 16.0003 8C16.0003 3.58172 12.4186 0 8.0003 0C7.57633 0 7.16005 0.0329816 6.75391 0.0965192L6.96734 2.08858Z",
    fill: "#DEE2E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallGray);
export default __webpack_public_path__ + "static/media/small-gray.4ba65188bc66bee1c8f81cff6adebb15.svg";
export { ForwardRef as ReactComponent };